'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { EMPTY_SYMBOL, NOT_ENTERED } from '@module/mdrt-org/shared/utils/constants/string-constants';
import { AccountSettingsFormSection } from '@module/mdrt-org/shared/utils/enums/account-settings-form-section';
import { MembershipLevel } from '@module/mdrt-org/shared/utils/enums/membership';
import { formatDateYearMonthDay } from '@module/mdrt-org/shared/utils/helpers/formatters/date-formatters';
import { formatToMonetary } from '@module/mdrt-org/shared/utils/helpers/formatters/numeric-formatters';
import { useGetYesNoLabel } from '@module/mdrt-org/shared/utils/helpers/strings/use-get-yes-no-label';
import { type PaymentProductName, PaymentProductType, type ReceiptDto } from '@module/mdrt-org/shared/utils/types/reseipt';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { ArrowIcon } from '@shared/ui-components/svgs';
import { type MembershipInvoicePage } from '../data/get-membership-invoice-page';
import { ContactSection } from './contact-section/contact-section';
import styles from './membership-invoice.module.scss';
export type MembershipInvoiceProps = {
  lastYearOfMembership: number;
  membershipInvoice: ReceiptDto;
  membershipInvoicePageContent: MembershipInvoicePage;
};
export const valueOrEmptySymbol = (value: null | number | string | undefined): number | string => value || EMPTY_SYMBOL;
export const enumKeyByValue = <T extends Record<string, string>,>(enumeration: T, enumValue: (typeof enumeration)[keyof typeof enumeration]): keyof T => Object.keys(enumeration).find(key => enumeration[key] === enumValue) as keyof T;
export const getMembershipLevelKeys = () => ({
  cotLevelKey: enumKeyByValue(MembershipLevel, MembershipLevel.COT),
  mdrtLevelKey: enumKeyByValue(MembershipLevel, MembershipLevel.MDRT),
  totLevelKey: enumKeyByValue(MembershipLevel, MembershipLevel.TOT)
});
export const MembershipInvoice = t0 => {
  const $ = _c(211);
  const {
    lastYearOfMembership,
    membershipInvoice,
    membershipInvoicePageContent
  } = t0;
  const getYesNoLabel = useGetYesNoLabel();
  const totalAmount = membershipInvoice?.totalAmountPaid && membershipInvoice?.totalAmountPaid > 0 ? membershipInvoice?.totalAmountPaid : 0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== getYesNoLabel || $[1] !== lastYearOfMembership || $[2] !== membershipInvoice || $[3] !== membershipInvoicePageContent) {
    const levelsPaymentProducts = membershipInvoice?.products?.filter(_temp) ?? [];
    const backDuesPaymentProduct = membershipInvoice?.products?.filter(_temp2) ?? [];
    const lateFeesPaymentProduct = membershipInvoice?.products?.filter(_temp3) ?? [];
    let t19;
    if ($[22] !== membershipInvoicePageContent) {
      t19 = productName => {
        const {
          cotLevelKey,
          mdrtLevelKey,
          totLevelKey
        } = getMembershipLevelKeys();
        if (!membershipInvoicePageContent) {
          return "";
        }
        switch (productName) {
          case "BackDues":
            {
              return membershipInvoicePageContent.backDuesLabel;
            }
          case cotLevelKey:
            {
              return membershipInvoicePageContent.COTLevelLabel;
            }
          case mdrtLevelKey:
            {
              return membershipInvoicePageContent.MDRTLevelLabel;
            }
          case totLevelKey:
            {
              return membershipInvoicePageContent.TOTLevelLabel;
            }
          default:
            {
              return EMPTY_SYMBOL;
            }
        }
      };
      $[22] = membershipInvoicePageContent;
      $[23] = t19;
    } else {
      t19 = $[23];
    }
    const getProductNameLabel = t19;
    let t20;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <ArrowIcon className={styles["actions__button-icon"]} />;
      $[24] = t20;
    } else {
      t20 = $[24];
    }
    const t21 = `${membershipInvoicePageContent.pagePaths.accountSettingPagePath}#${AccountSettingsFormSection.Profile}`;
    let t22;
    if ($[25] !== membershipInvoicePageContent.backButtonLabel || $[26] !== t21) {
      t22 = <Button isSmall={true} prefix={t20} to={t21} variant={ButtonVariant.Tertiary}>{membershipInvoicePageContent.backButtonLabel}</Button>;
      $[25] = membershipInvoicePageContent.backButtonLabel;
      $[26] = t21;
      $[27] = t22;
    } else {
      t22 = $[27];
    }
    let t23;
    if ($[28] !== membershipInvoicePageContent.printButtonLabel) {
      t23 = <Button onClick={_temp4}>{membershipInvoicePageContent.printButtonLabel}</Button>;
      $[28] = membershipInvoicePageContent.printButtonLabel;
      $[29] = t23;
    } else {
      t23 = $[29];
    }
    if ($[30] !== t22 || $[31] !== t23) {
      t18 = <div className={styles.actions}>{t22}{t23}</div>;
      $[30] = t22;
      $[31] = t23;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    t11 = styles.receipt;
    t12 = "receipt-section";
    if ($[33] !== lastYearOfMembership || $[34] !== membershipInvoicePageContent) {
      t13 = <ContactSection membershipInvoicePageContent={membershipInvoicePageContent} membershipYear={lastYearOfMembership} />;
      $[33] = lastYearOfMembership;
      $[34] = membershipInvoicePageContent;
      $[35] = t13;
    } else {
      t13 = $[35];
    }
    if ($[36] !== membershipInvoicePageContent.invoiceHeader) {
      t14 = <div className={styles.receipt__header}><h1 data-testid="receipt-header">{membershipInvoicePageContent.invoiceHeader}</h1></div>;
      $[36] = membershipInvoicePageContent.invoiceHeader;
      $[37] = t14;
    } else {
      t14 = $[37];
    }
    let t24;
    if ($[38] !== membershipInvoicePageContent.memberDetailsHeader) {
      t24 = <h3 className={styles["receipt__section-title"]}>{membershipInvoicePageContent.memberDetailsHeader}</h3>;
      $[38] = membershipInvoicePageContent.memberDetailsHeader;
      $[39] = t24;
    } else {
      t24 = $[39];
    }
    const t25 = membershipInvoice?.memberFullName || NOT_ENTERED;
    let t26;
    if ($[40] !== t25) {
      t26 = <strong>{t25}</strong>;
      $[40] = t25;
      $[41] = t26;
    } else {
      t26 = $[41];
    }
    let t27;
    if ($[42] !== membershipInvoicePageContent.memberNameLabel || $[43] !== t26) {
      t27 = <p className={styles["receipt__section-item"]} data-testid="member-name-row">{membershipInvoicePageContent.memberNameLabel}{t26}</p>;
      $[42] = membershipInvoicePageContent.memberNameLabel;
      $[43] = t26;
      $[44] = t27;
    } else {
      t27 = $[44];
    }
    const t28 = membershipInvoicePageContent.MDRTIdLabel;
    const t29 = membershipInvoice?.mdrtId;
    let t30;
    if ($[45] !== t29) {
      t30 = valueOrEmptySymbol(t29);
      $[45] = t29;
      $[46] = t30;
    } else {
      t30 = $[46];
    }
    let t31;
    if ($[47] !== t30) {
      t31 = <strong>{t30}</strong>;
      $[47] = t30;
      $[48] = t31;
    } else {
      t31 = $[48];
    }
    let t32;
    if ($[49] !== membershipInvoicePageContent.MDRTIdLabel || $[50] !== t31) {
      t32 = <p className={styles["receipt__section-item"]} data-testid="mdrt-id-row">{t28}{t31}</p>;
      $[49] = membershipInvoicePageContent.MDRTIdLabel;
      $[50] = t31;
      $[51] = t32;
    } else {
      t32 = $[51];
    }
    const t33 = membershipInvoicePageContent.phoneNumberLabel;
    const t34 = membershipInvoice?.phoneNumber;
    let t35;
    if ($[52] !== t34) {
      t35 = valueOrEmptySymbol(t34);
      $[52] = t34;
      $[53] = t35;
    } else {
      t35 = $[53];
    }
    let t36;
    if ($[54] !== t35) {
      t36 = <strong>{t35}</strong>;
      $[54] = t35;
      $[55] = t36;
    } else {
      t36 = $[55];
    }
    let t37;
    if ($[56] !== membershipInvoicePageContent.phoneNumberLabel || $[57] !== t36) {
      t37 = <p className={styles["receipt__section-item"]} data-testid="phone-number-row">{t33}{t36}</p>;
      $[56] = membershipInvoicePageContent.phoneNumberLabel;
      $[57] = t36;
      $[58] = t37;
    } else {
      t37 = $[58];
    }
    const t38 = membershipInvoicePageContent.companyNameLabel;
    const t39 = membershipInvoice?.companyName;
    let t40;
    if ($[59] !== t39) {
      t40 = valueOrEmptySymbol(t39);
      $[59] = t39;
      $[60] = t40;
    } else {
      t40 = $[60];
    }
    let t41;
    if ($[61] !== t40) {
      t41 = <strong>{t40}</strong>;
      $[61] = t40;
      $[62] = t41;
    } else {
      t41 = $[62];
    }
    let t42;
    if ($[63] !== membershipInvoicePageContent.companyNameLabel || $[64] !== t41) {
      t42 = <p className={styles["receipt__section-item"]} data-testid="company-name-row">{t38}{t41}</p>;
      $[63] = membershipInvoicePageContent.companyNameLabel;
      $[64] = t41;
      $[65] = t42;
    } else {
      t42 = $[65];
    }
    let t43;
    if ($[66] !== t27 || $[67] !== t32 || $[68] !== t37 || $[69] !== t42) {
      t43 = <div className={styles["receipt__section-content"]}>{t27}{t32}{t37}{t42}</div>;
      $[66] = t27;
      $[67] = t32;
      $[68] = t37;
      $[69] = t42;
      $[70] = t43;
    } else {
      t43 = $[70];
    }
    if ($[71] !== t24 || $[72] !== t43) {
      t15 = <div className={styles.receipt__section} data-testid="member-details-section">{t24}{t43}</div>;
      $[71] = t24;
      $[72] = t43;
      $[73] = t15;
    } else {
      t15 = $[73];
    }
    let t44;
    if ($[74] !== membershipInvoicePageContent.applicationDetailsHeader) {
      t44 = <h3 className={styles["receipt__section-title"]}>{membershipInvoicePageContent.applicationDetailsHeader}</h3>;
      $[74] = membershipInvoicePageContent.applicationDetailsHeader;
      $[75] = t44;
    } else {
      t44 = $[75];
    }
    const t45 = membershipInvoicePageContent.termsAndConditionsLabel;
    const t46 = membershipInvoice?.acceptedTermsAndConditions;
    let t47;
    if ($[76] !== getYesNoLabel || $[77] !== t46) {
      t47 = getYesNoLabel(t46);
      $[76] = getYesNoLabel;
      $[77] = t46;
      $[78] = t47;
    } else {
      t47 = $[78];
    }
    let t48;
    if ($[79] !== t47) {
      t48 = <strong className={styles["receipt__section-item-value--capitalized"]}>{t47}</strong>;
      $[79] = t47;
      $[80] = t48;
    } else {
      t48 = $[80];
    }
    let t49;
    if ($[81] !== membershipInvoicePageContent.termsAndConditionsLabel || $[82] !== t48) {
      t49 = <p className={styles["receipt__section-item"]} data-testid="terms-and-conditions-row">{t45}{t48}</p>;
      $[81] = membershipInvoicePageContent.termsAndConditionsLabel;
      $[82] = t48;
      $[83] = t49;
    } else {
      t49 = $[83];
    }
    const t50 = membershipInvoicePageContent.ethicsComplaintLabel;
    const t51 = membershipInvoice?.hasEthicsComplaint;
    let t52;
    if ($[84] !== getYesNoLabel || $[85] !== t51) {
      t52 = getYesNoLabel(t51);
      $[84] = getYesNoLabel;
      $[85] = t51;
      $[86] = t52;
    } else {
      t52 = $[86];
    }
    let t53;
    if ($[87] !== t52) {
      t53 = <strong className={styles["receipt__section-item-value--capitalized"]}>{t52}</strong>;
      $[87] = t52;
      $[88] = t53;
    } else {
      t53 = $[88];
    }
    let t54;
    if ($[89] !== membershipInvoicePageContent.ethicsComplaintLabel || $[90] !== t53) {
      t54 = <p className={styles["receipt__section-item"]} data-testid="ethics-complaint-row">{t50}{t53}</p>;
      $[89] = membershipInvoicePageContent.ethicsComplaintLabel;
      $[90] = t53;
      $[91] = t54;
    } else {
      t54 = $[91];
    }
    const t55 = membershipInvoicePageContent.disabilityRequestedLabel;
    const t56 = membershipInvoice?.disabilityRequested;
    let t57;
    if ($[92] !== getYesNoLabel || $[93] !== t56) {
      t57 = getYesNoLabel(t56);
      $[92] = getYesNoLabel;
      $[93] = t56;
      $[94] = t57;
    } else {
      t57 = $[94];
    }
    let t58;
    if ($[95] !== t57) {
      t58 = <strong className={styles["receipt__section-item-value--capitalized"]}>{t57}</strong>;
      $[95] = t57;
      $[96] = t58;
    } else {
      t58 = $[96];
    }
    let t59;
    if ($[97] !== membershipInvoicePageContent.disabilityRequestedLabel || $[98] !== t58) {
      t59 = <p className={styles["receipt__section-item"]} data-testid="disability-row">{t55}{t58}</p>;
      $[97] = membershipInvoicePageContent.disabilityRequestedLabel;
      $[98] = t58;
      $[99] = t59;
    } else {
      t59 = $[99];
    }
    const t60 = membershipInvoicePageContent.membershipTypeLabel;
    const t61 = membershipInvoice?.membershipType;
    let t62;
    if ($[100] !== t61) {
      t62 = valueOrEmptySymbol(t61);
      $[100] = t61;
      $[101] = t62;
    } else {
      t62 = $[101];
    }
    let t63;
    if ($[102] !== t62) {
      t63 = <strong>{t62}</strong>;
      $[102] = t62;
      $[103] = t63;
    } else {
      t63 = $[103];
    }
    let t64;
    if ($[104] !== membershipInvoicePageContent.membershipTypeLabel || $[105] !== t63) {
      t64 = <p className={styles["receipt__section-item"]} data-testid="membership-type-row">{t60}{t63}</p>;
      $[104] = membershipInvoicePageContent.membershipTypeLabel;
      $[105] = t63;
      $[106] = t64;
    } else {
      t64 = $[106];
    }
    const t65 = membershipInvoicePageContent.attestToProduction;
    const t66 = membershipInvoice?.attestedToProduction;
    let t67;
    if ($[107] !== getYesNoLabel || $[108] !== t66) {
      t67 = getYesNoLabel(t66);
      $[107] = getYesNoLabel;
      $[108] = t66;
      $[109] = t67;
    } else {
      t67 = $[109];
    }
    let t68;
    if ($[110] !== t67) {
      t68 = <strong className={styles["receipt__section-item-value--capitalized"]}>{t67}</strong>;
      $[110] = t67;
      $[111] = t68;
    } else {
      t68 = $[111];
    }
    let t69;
    if ($[112] !== membershipInvoicePageContent.attestToProduction || $[113] !== t68) {
      t69 = <p className={styles["receipt__section-item"]} data-testid="attest-row">{t65}{t68}</p>;
      $[112] = membershipInvoicePageContent.attestToProduction;
      $[113] = t68;
      $[114] = t69;
    } else {
      t69 = $[114];
    }
    let t70;
    if ($[115] !== t49 || $[116] !== t54 || $[117] !== t59 || $[118] !== t64 || $[119] !== t69) {
      t70 = <div className={styles["receipt__section-content"]}>{t49}{t54}{t59}{t64}{t69}</div>;
      $[115] = t49;
      $[116] = t54;
      $[117] = t59;
      $[118] = t64;
      $[119] = t69;
      $[120] = t70;
    } else {
      t70 = $[120];
    }
    if ($[121] !== t44 || $[122] !== t70) {
      t16 = <div className={styles.receipt__section} data-testid="application-details-section">{t44}{t70}</div>;
      $[121] = t44;
      $[122] = t70;
      $[123] = t16;
    } else {
      t16 = $[123];
    }
    let t71;
    if ($[124] !== membershipInvoicePageContent.paymentDetailsHeader) {
      t71 = <h3 className={styles["receipt__section-title"]}>{membershipInvoicePageContent.paymentDetailsHeader}</h3>;
      $[124] = membershipInvoicePageContent.paymentDetailsHeader;
      $[125] = t71;
    } else {
      t71 = $[125];
    }
    const t72 = membershipInvoicePageContent.paymentDateLabel;
    const t73 = membershipInvoice?.paymentDate || undefined;
    let t74;
    if ($[126] !== t73) {
      t74 = formatDateYearMonthDay(t73);
      $[126] = t73;
      $[127] = t74;
    } else {
      t74 = $[127];
    }
    let t75;
    if ($[128] !== t74) {
      t75 = <strong>{t74}</strong>;
      $[128] = t74;
      $[129] = t75;
    } else {
      t75 = $[129];
    }
    let t76;
    if ($[130] !== membershipInvoicePageContent.paymentDateLabel || $[131] !== t75) {
      t76 = <p className={styles["receipt__section-item"]} data-testid="payment-date-row">{t72}{t75}</p>;
      $[130] = membershipInvoicePageContent.paymentDateLabel;
      $[131] = t75;
      $[132] = t76;
    } else {
      t76 = $[132];
    }
    const t77 = membershipInvoicePageContent.orderNumberLabel;
    const t78 = membershipInvoice?.orderNumber;
    let t79;
    if ($[133] !== t78) {
      t79 = valueOrEmptySymbol(t78);
      $[133] = t78;
      $[134] = t79;
    } else {
      t79 = $[134];
    }
    let t80;
    if ($[135] !== t79) {
      t80 = <strong>{t79}</strong>;
      $[135] = t79;
      $[136] = t80;
    } else {
      t80 = $[136];
    }
    let t81;
    if ($[137] !== membershipInvoicePageContent.orderNumberLabel || $[138] !== t80) {
      t81 = <p className={styles["receipt__section-item"]} data-testid="order-number-row">{t77}{t80}</p>;
      $[137] = membershipInvoicePageContent.orderNumberLabel;
      $[138] = t80;
      $[139] = t81;
    } else {
      t81 = $[139];
    }
    const t82 = membershipInvoicePageContent.paymentMethodLabel;
    const t83 = membershipInvoice?.paymentMethod;
    let t84;
    if ($[140] !== t83) {
      t84 = valueOrEmptySymbol(t83);
      $[140] = t83;
      $[141] = t84;
    } else {
      t84 = $[141];
    }
    let t85;
    if ($[142] !== t84) {
      t85 = <strong>{t84}</strong>;
      $[142] = t84;
      $[143] = t85;
    } else {
      t85 = $[143];
    }
    let t86;
    if ($[144] !== membershipInvoicePageContent.paymentMethodLabel || $[145] !== t85) {
      t86 = <p className={styles["receipt__section-item"]} data-testid="payment-method-row">{t82}{t85}</p>;
      $[144] = membershipInvoicePageContent.paymentMethodLabel;
      $[145] = t85;
      $[146] = t86;
    } else {
      t86 = $[146];
    }
    let t87;
    if ($[147] !== t76 || $[148] !== t81 || $[149] !== t86) {
      t87 = <div className={styles["receipt__section-content"]}>{t76}{t81}{t86}</div>;
      $[147] = t76;
      $[148] = t81;
      $[149] = t86;
      $[150] = t87;
    } else {
      t87 = $[150];
    }
    if ($[151] !== t71 || $[152] !== t87) {
      t17 = <div className={styles.receipt__section} data-testid="payment-details-section">{t71}{t87}</div>;
      $[151] = t71;
      $[152] = t87;
      $[153] = t17;
    } else {
      t17 = $[153];
    }
    t8 = styles.receipt__section;
    t9 = "price-breakdown-section";
    if ($[154] !== membershipInvoicePageContent.priceBreakdownHeader) {
      t10 = <h3 className={styles["receipt__section-title"]}>{membershipInvoicePageContent.priceBreakdownHeader}</h3>;
      $[154] = membershipInvoicePageContent.priceBreakdownHeader;
      $[155] = t10;
    } else {
      t10 = $[155];
    }
    t1 = styles["receipt__section-content"];
    const t88 = membershipInvoicePageContent.companyPrePaymentLabel;
    const t89 = membershipInvoice?.companyPrePayment && -membershipInvoice.companyPrePayment;
    let t90;
    if ($[156] !== t89) {
      t90 = formatToMonetary(t89, {}, false);
      $[156] = t89;
      $[157] = t90;
    } else {
      t90 = $[157];
    }
    let t91;
    if ($[158] !== t90) {
      t91 = <strong>{t90}</strong>;
      $[158] = t90;
      $[159] = t91;
    } else {
      t91 = $[159];
    }
    if ($[160] !== membershipInvoicePageContent.companyPrePaymentLabel || $[161] !== t91) {
      t2 = <p className={styles["receipt__section-item"]} data-testid="company-prepayment-row">{t88}{t91}</p>;
      $[160] = membershipInvoicePageContent.companyPrePaymentLabel;
      $[161] = t91;
      $[162] = t2;
    } else {
      t2 = $[162];
    }
    const t92 = membershipInvoicePageContent.selfPrePaymentLabel;
    const t93 = membershipInvoice?.selfPrePayment && -membershipInvoice.selfPrePayment;
    let t94;
    if ($[163] !== t93) {
      t94 = formatToMonetary(t93, {}, false);
      $[163] = t93;
      $[164] = t94;
    } else {
      t94 = $[164];
    }
    let t95;
    if ($[165] !== t94) {
      t95 = <strong>{t94}</strong>;
      $[165] = t94;
      $[166] = t95;
    } else {
      t95 = $[166];
    }
    if ($[167] !== membershipInvoicePageContent.selfPrePaymentLabel || $[168] !== t95) {
      t3 = <p className={styles["receipt__section-item"]} data-testid="self-prepayment-row">{t92}{t95}</p>;
      $[167] = membershipInvoicePageContent.selfPrePaymentLabel;
      $[168] = t95;
      $[169] = t3;
    } else {
      t3 = $[169];
    }
    if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <hr />;
      $[170] = t4;
    } else {
      t4 = $[170];
    }
    t5 = levelsPaymentProducts?.length > 0 && levelsPaymentProducts?.map(product_2 => <p className={styles["receipt__section-item"]} data-testid={`${product_2.productName}-price-row`} key={product_2.productId}>{getProductNameLabel(product_2.productName)}<strong>{formatToMonetary(product_2?.amount ?? 0, {}, false)}</strong></p>);
    t6 = backDuesPaymentProduct?.length > 0 && backDuesPaymentProduct?.map(product_3 => <p className={styles["receipt__section-item"]} data-testid={`${product_3.productName}-price-row`} key={product_3.productId}>{membershipInvoicePageContent.backDuesLabel}<strong>{formatToMonetary(product_3?.amount ?? 0, {}, false)}</strong></p>);
    t7 = lateFeesPaymentProduct?.length > 0 && lateFeesPaymentProduct?.map(product_4 => <p className={styles["receipt__section-item"]} data-testid={`${product_4.productName}-price-row`} key={product_4.productId}>{membershipInvoicePageContent.lateFeeLabel}<strong>{formatToMonetary(product_4?.amount ?? 0, {}, false)}</strong></p>);
    $[0] = getYesNoLabel;
    $[1] = lastYearOfMembership;
    $[2] = membershipInvoice;
    $[3] = membershipInvoicePageContent;
    $[4] = t1;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t1 = $[4];
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t17 = $[12];
    t18 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t19;
  if ($[171] !== membershipInvoice?.additionalFees || $[172] !== membershipInvoicePageContent.additionalFilingFeesLabel) {
    t19 = Boolean(membershipInvoice?.additionalFees) && <p className={styles["receipt__section-item"]} data-testid="additional-fee-row">{membershipInvoicePageContent.additionalFilingFeesLabel}<strong>{formatToMonetary(membershipInvoice?.additionalFees ?? 0, {}, false)}</strong></p>;
    $[171] = membershipInvoice?.additionalFees;
    $[172] = membershipInvoicePageContent.additionalFilingFeesLabel;
    $[173] = t19;
  } else {
    t19 = $[173];
  }
  let t20;
  if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <hr />;
    $[174] = t20;
  } else {
    t20 = $[174];
  }
  let t21;
  if ($[175] !== membershipInvoicePageContent.totalAmountPaidLabel) {
    t21 = <strong>{membershipInvoicePageContent.totalAmountPaidLabel}</strong>;
    $[175] = membershipInvoicePageContent.totalAmountPaidLabel;
    $[176] = t21;
  } else {
    t21 = $[176];
  }
  let t22;
  if ($[177] !== totalAmount) {
    t22 = formatToMonetary(totalAmount, {}, false);
    $[177] = totalAmount;
    $[178] = t22;
  } else {
    t22 = $[178];
  }
  let t23;
  if ($[179] !== t22) {
    t23 = <strong>{t22}</strong>;
    $[179] = t22;
    $[180] = t23;
  } else {
    t23 = $[180];
  }
  let t24;
  if ($[181] !== t21 || $[182] !== t23) {
    t24 = <p className={styles["receipt__section-item"]} data-testid="total-amount-row">{t21}{t23}</p>;
    $[181] = t21;
    $[182] = t23;
    $[183] = t24;
  } else {
    t24 = $[183];
  }
  let t25;
  if ($[184] !== t1 || $[185] !== t19 || $[186] !== t2 || $[187] !== t24 || $[188] !== t3 || $[189] !== t4 || $[190] !== t5 || $[191] !== t6 || $[192] !== t7) {
    t25 = <div className={t1}>{t2}{t3}{t4}{t5}{t6}{t7}{t19}{t20}{t24}</div>;
    $[184] = t1;
    $[185] = t19;
    $[186] = t2;
    $[187] = t24;
    $[188] = t3;
    $[189] = t4;
    $[190] = t5;
    $[191] = t6;
    $[192] = t7;
    $[193] = t25;
  } else {
    t25 = $[193];
  }
  let t26;
  if ($[194] !== t10 || $[195] !== t25 || $[196] !== t8 || $[197] !== t9) {
    t26 = <div className={t8} data-testid={t9}>{t10}{t25}</div>;
    $[194] = t10;
    $[195] = t25;
    $[196] = t8;
    $[197] = t9;
    $[198] = t26;
  } else {
    t26 = $[198];
  }
  let t27;
  if ($[199] !== t11 || $[200] !== t12 || $[201] !== t13 || $[202] !== t14 || $[203] !== t15 || $[204] !== t16 || $[205] !== t17 || $[206] !== t26) {
    t27 = <section className={t11} data-testid={t12}>{t13}{t14}{t15}{t16}{t17}{t26}</section>;
    $[199] = t11;
    $[200] = t12;
    $[201] = t13;
    $[202] = t14;
    $[203] = t15;
    $[204] = t16;
    $[205] = t17;
    $[206] = t26;
    $[207] = t27;
  } else {
    t27 = $[207];
  }
  let t28;
  if ($[208] !== t18 || $[209] !== t27) {
    t28 = <>{t18}{t27}</>;
    $[208] = t18;
    $[209] = t27;
    $[210] = t28;
  } else {
    t28 = $[210];
  }
  return t28;
};
function _temp(product) {
  return product.type === PaymentProductType.Level;
}
function _temp2(product_0) {
  return product_0.type === PaymentProductType.BackDues;
}
function _temp3(product_1) {
  return product_1.type === PaymentProductType.LateFees;
}
function _temp4() {
  return window.print();
}